import { Row } from "antd";
import moment from "moment";
import React from "react";
import "./styles.css";
import { useSelector } from "react-redux";

export function CandidateCancelledCard({ data, status }) {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  let BidType = data?.OfferCard?.BidType;
  const isProposal = BidType === "Proposal";
  const card = isProposal ? data?.ProposalCard : data?.BidCard;
  const rate = card?.extendContract?.Rate;
  const budgetType = card?.extendContract?.BudgetType;
  return (
    <>
      {/* status == "Candidate Cancelled" || status == "Candidate Terminated" && */}
      {/* { ( */}
      <>
        <div>
          {/* <strong>Sorry!</strong> */}
          <p>You've {status == "Candidate Cancelled" ? 'canceled' : 'terminated'} the candidate’s contract.</p>
        </div>
        <div className="onBilling-card-info-div">
          <Row className="info-style">
            <strong>Start date</strong>
            <div>
              {
                moment(
                  data?.OfferCard?.BidType === "Proposal"
                    ? data?.ProposalCard?.extendContract?.StartDate || data?.OfferCard?.FromDate
                    : data?.BidCard?.extendContract?.StartDate || data?.OfferCard?.FromDate
                ).format('DD.MM.yyyy')
              }
            </div>
          </Row>
          <Row className="info-style">
            <strong>End date</strong>
            <div>

              {
                moment(
                  data?.OfferCard?.BidType === "Proposal"
                    ? data?.ProposalCard?.extendContract?.EndDate || data?.OfferCard?.ToDate
                    : data?.BidCard?.extendContract?.EndDate || data?.OfferCard?.ToDate
                ).format('DD.MM.yyyy')
              }

            </div>
          </Row>
          {userProfile?.Professions?.ProfessionCode != "IT" ? (
            <Row className="info-style">
              <strong>Pay package</strong>
              <div>
              {
  (Object.keys(card?.extendContract || {}).length > 0)
    ? `\$${rate} / ${budgetType === "Week" ? "WK" : "HR"}`
    : `${data?.OfferCard?.Currency} ${parseInt(data?.OfferCard?.Rate).toLocaleString('en-US')}/${
        (data?.OfferCard?.BudgetType === "hr" || data?.OfferCard?.BudgetType === "Hourly") ? "HR" :
        (data?.OfferCard?.BudgetType === "yr" || data?.OfferCard?.BudgetType === "Year") ? "YR" :
        (data?.OfferCard?.BudgetType === "Weekly" || data?.OfferCard?.BudgetType === "wk") ? "WK" :
        "YR"
      }`
}

              </div>
            </Row>
          ) : null}
          <Row className="info-style">
            <strong>Contract duration</strong>
            <div>
              {
                data?.OfferCard?.BidType === "Proposal"
                  ? data?.ProposalCard?.extendContract?.ContractDuration ?? data?.OfferCard?.Duration
                  : data?.BidCard?.extendContract?.ContractDuration ?? data?.OfferCard?.Duration
              }

            </div>
          </Row>
        </div>
      </>
      {/* )} */}
    </>
  );
}
